"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonNullValueInputSchema = void 0;
const zod_1 = require("zod");
exports.JsonNullValueInputSchema = zod_1.z.enum(['JsonNull',]);
exports.default = exports.JsonNullValueInputSchema;
//# sourceMappingURL=JsonNullValueInputSchema.js.map